<template>
  <div id="__Announcements">
    <CPageTitle :title="$t('Information')" backable @back="onBack" />

    <CPanel>
      <template v-if="getUrgentAnnouncements.length">
        <CTitle>
          <CIcon name="error_outline" material class="danger-color text-lg mr-xxs" />
          {{ $t('Important information') }}
        </CTitle>
        <AnnouncementList :data="getUrgentAnnouncements" />
        <CSeparator spaced />
      </template>

      <CTitle>{{ $t('Information') }}</CTitle>
      <AnnouncementList :data="getFilteredAnnouncements" />
    </CPanel>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import CPageTitle from '@/components/uikit/CPageTitle';
import CPanel from '@/components/uikit/CPanel';
import CTitle from '@/components/uikit/CTitle';
import CIcon from '@/components/uikit/CIcon';
import CSeparator from '@/components/uikit/CSeparator';
import AnnouncementList from '@/pages/Announcements/AnnouncementList';

const messages = {
  en: {
    'Information list': 'Announcements',
    'Important information': 'Important information',
    Information: 'Announcements',
  },
  ja: {
    'Information list': 'お知らせ一覧',
    'Important information': '重要なお知らせ',
    Information: 'お知らせ',
  },
};

export default Vue.extend({
  name: 'Announcements',
  i18n: { messages },
  components: { CPageTitle, CPanel, CTitle, CIcon, CSeparator, AnnouncementList },
  computed: {
    ...mapGetters('announcements', ['getUrgentAnnouncements', 'getFilteredAnnouncements']),
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },
  },
});
</script>

<style lang="scss" scoped>
#__Announcements {
  padding: $space-md $space-xs;
}
</style>
